import { useContext } from "react"
import { FibConfigContext } from "../components/FibConfigProvider"


export default function useFibConfig() {
    const context = useContext(FibConfigContext)

    if (!context) {
        throw new Error("Debes utilizar el hook useFibConfig dentro del FibConfigProvider")
    }

    return context
}